import PropTypes from 'prop-types';
import React from 'react';

const InsetContainer = require('components/common/containers/inset_container').default;
import InformationI from 'components/common/icons/information_i.jsx';
import Tooltip from 'components/common/tooltip';

export default function ResultsHeader({ isLookupPending, resultsCount, shouldShowSuggestions, suggestionsCount }) {
  let header;

  if (isLookupPending) {
    header = <span>Searching for matches...</span>;
  } else if (shouldShowSuggestions) {
    header = (
      <InsetContainer inset="large">
        <div>
          We found{' '}
          <span className="externalCustomerLookupSearchResults-header-text-highlight">
            {suggestionsCount} possible matches.
          </span>{' '}
          Try searching for other matches
          <div className="externalCustomerLookupSearchResults-header-tooltipIcon-container">
            <Tooltip enabled message="Results are based on the customer’s profile information." position="bottom">
              <InformationI className="externalCustomerLookupSearchResults-header-tooltipIcon" />
            </Tooltip>
          </div>
        </div>
      </InsetContainer>
    );
  } else {
    header = (
      <InsetContainer inset="large">
        <p>
          We found{' '}
          <span className="externalCustomerLookupSearchResults-header-text-highlight">
            {resultsCount} possible matches.
          </span>{' '}
          Try refining your search for better results
        </p>
      </InsetContainer>
    );
  }

  return <div className="externalCustomerLookupSearchResults-header">{header}</div>;
}

ResultsHeader.propTypes = {
  isLookupPending: PropTypes.bool,
  resultsCount: PropTypes.number.isRequired,
  shouldShowSuggestions: PropTypes.bool,
  suggestionsCount: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/external_customer_lookup/results_header.jsx